import { useEffect, useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@cbhq/cds-web/buttons';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { Box } from '@cbhq/cds-web/layout/Box';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { Link } from '@cbhq/cds-web/typography';
import { TextBody } from '@cbhq/cds-web/typography/TextBody';
import { COOKIE_BANNER_ANIMATION_DURATION_IN_SECONDS } from '../constants.js';
import useEffectOnUpdate from '../hooks/useEffectOnUpdate.js';
import { useTrackingManager } from '../TrackingManagerContext.js';
import useMessages from './useMessages.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function BannerContent({
  onDismiss,
  onAccept,
  showPreferencesModal,
  hasDismissed,
  sidebarWidth,
  onBannerWillEnter,
  onBannerWillExit,
  bannerRef,
  isVisible,
  closeWithTransition
}) {
  const _useTrackingManager = useTrackingManager(),
    log = _useTrackingManager.log;
  const _useBreakpoints = useBreakpoints(),
    isPhone = _useBreakpoints.isPhone;
  useEffectOnUpdate(() => {
    if (isVisible) {
      onBannerWillEnter?.();
    } else {
      onBannerWillExit?.();
    }
  }, [isVisible]);
  useEffect(() => {
    if (!hasDismissed) {
      log('cookie_consent_footer_viewed');
    }
  }, []);
  const handleDismiss = useCallback(() => {
    log('cookie_consent_footer_dismissed');
    closeWithTransition(onDismiss);
  }, [onDismiss, closeWithTransition, log]);
  const handleClick = useCallback(() => {
    closeWithTransition(onAccept);
  }, [onAccept, closeWithTransition]);
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const messages = useMessages();
  if (hasDismissed) {
    return null;
  }
  return /*#__PURE__*/jsx(Box, {
    position: "fixed",
    bottom: isVisible ? 0 : -300,
    zIndex: 1000,
    background: "backgroundAlternate",
    justifyContent: "center",
    spacing: 2,
    left: sidebarWidth ?? 0,
    right: 0,
    style: {
      transition: `bottom ${COOKIE_BANNER_ANIMATION_DURATION_IN_SECONDS}s`
    },
    ref: bannerRef,
    children: /*#__PURE__*/jsxs(Box, {
      flexDirection: isPhone ? 'column' : 'row',
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/jsx(TextBody, {
        as: "p",
        spacingBottom: isPhone ? 2 : 0,
        spacingEnd: isPhone ? 0 : 2,
        children: formatMessage(messages.defaultBannerDescription, {
          link: node => [/*#__PURE__*/jsx(Link, {
            to: "https://www.coinbase.com/legal/cookie#:~:text=Targeting%20purposes,to%20you%20or%20your%20interests.",
            openInNewWindow: true,
            referrerPolicy: "no-referrer",
            children: node ?? ''
          })],
          button: node => [/*#__PURE__*/jsx(Link, {
            variant: "body",
            underline: true,
            onPress: showPreferencesModal,
            children: node ?? ''
          })]
        })
      }), /*#__PURE__*/jsxs(HStack, {
        gap: 2,
        alignItems: "center",
        width: isPhone ? '100%' : 'auto',
        children: [/*#__PURE__*/jsx(Button, {
          onPress: handleDismiss,
          compact: true,
          variant: "secondary",
          block: isPhone,
          children: formatMessage(messages.bannerCloseCTA)
        }), /*#__PURE__*/jsx(Button, {
          onPress: handleClick,
          compact: true,
          block: isPhone,
          testID: "cookie-banner-accept-all",
          children: formatMessage(messages.bannerMainCTA)
        })]
      })]
    })
  });
}
const BannerContent$1 = /*#__PURE__*/memo(BannerContent);
export { BannerContent$1 as default };
//# sourceMappingURL=CookieBannerContent.js.map
